/**
 * 全局图片多选底部工具栏规范
 *
 * 固定按钮（从左到右，取消选择在右侧）：
 * 1. 取消选择 — 清空当前选中
 * 2. 禁用 — 将选中项标记为不再使用（卡片灰色遮罩 + 右上角禁用图标，点击图标恢复）
 * 3. 下载 — 橙色图标+文案，仅处理未禁用的选中项
 *
 * 各页面可在固定按钮前通过 children / extraActions 插入扩展操作（如全选、快速选中、删除等）。
 */
export const GALLERY_SELECTION_TOOLBAR = {
  cancelLabel: '取消选择',
  disableLabel: '禁用',
  downloadLabel: '下载',
  deleteLabel: '删除',
};
